<template>
  <button class="checkbox" type="button" :checked="checked" @click="toggle">
    <i v-if="checked" class="far fa-check-square"></i>
    <i v-else class="far fa-square"></i>
  </button>
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    value() {
      this.checked = this.value
    }
  },
  methods: {
    toggle() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    }
  },
  mounted: function() {
    this.checked = this.value
  }
}
</script>

<style scoped>
.checkbox {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  padding: 0;
  color: #00A1ED;
}

.checkbox i {
  display: block;
  font-size: 14px;
}
</style>
